
import { Component, Mixins, Prop } from "vue-property-decorator";
import FormLogin from ".";
const Words: Dictionary = {
  error: "所属先IDまたは所属先パスワードに誤りがあります。",
  error2: "システムエラー",
  account: "所属先ID",
  password: "所属先パスワード",
  login: "ログイン",
};
@Component
export default class FormLoginShareholder extends Mixins(FormLogin) {
  @Prop({ default: true })
  showLineLogin!: boolean;

  private words = Words;
}
